<div class="tittel">{{ 'Deltatt'|translate }}</div>
@if (antallDeltatt() == 0) {
  <div class="ingen">{{ 'ingen'|translate }}</div>
} @else {
  @for (deltaker of skjema().controls.deltakere.controls; track deltaker.value.medlemId) {
    @if (deltaker.value.status == statuser.deltatt) {
      <moeteprotokoll-rediger-deltaker [skjema]="deltaker" [visRepresentererKolonne]="visRepresentererKolonne()" data-testid="deltaker-deltatt"/>
    }
  }
}

<div class="tittel">{{ 'Forfall'|translate }}</div>
@if (antallForfall() == 0) {
  <div class="ingen">{{ 'ingen'|translate }}</div>
} @else {
  @for (deltaker of skjema().controls.deltakere.controls; track deltaker.value.medlemId) {
    @if (deltaker.value.status == statuser.forfall) {
      <moeteprotokoll-rediger-deltaker [skjema]="deltaker" [visRepresentererKolonne]="visRepresentererKolonne()" data-testid="deltaker-forfall"/>
    }
  }
}

<div class="tittel">{{ 'Ikke innkalt'|translate }}</div>
@if (antallIkkeInnkalt() == 0) {
  <div class="ingen">{{ 'ingen'|translate }}</div>
} @else {
  <div class="handling" (click)="endreViserIkkeInnkalte()" data-testid="vis-ikke-innkalte-knapp">
    @if (viserIkkeInnkalte()) {
      ({{ 'skjul'|translate }})
    } @else {
      ({{ 'vis {antall} medlemmer'|translate: {antall: antallIkkeInnkalt()} }})
    }
  </div>
  @if (viserIkkeInnkalte()) {
    @for (deltaker of skjema().controls.deltakere.controls; track deltaker.value.medlemId) {
      @if (deltaker.value.status == statuser.ikkeInnkalt) {
        <moeteprotokoll-rediger-deltaker [skjema]="deltaker" [visRepresentererKolonne]="visRepresentererKolonne()" data-testid="deltaker-ikkeInnkalt"/>
      }
    }
  }
}

<div class="tittel">
  {{ 'Eksterne'|translate }}
</div>
<div class="handling" (click)="endreViserEksterne()" data-testid="vis-eksterne-knapp">
  <!--eksponerer kun knapp for å vise/skjule dersom det ikke finnes noen eksterne (length==1 da skjemaet alltid inneholder en rad for å reg ny ekstern) -->
  @if (skjema().value.eksterneDeltakere!.length == 1) {
    @if (viserEksterne()) {
      ({{ 'skjul'|translate }})
    } @else {
      ({{ 'legg til'|translate }})
    }
  }
</div>
@if (viserEksterne()) {
  @for (deltaker of skjema().controls.eksterneDeltakere.controls; track deltaker.value.id; let indeks = $index) {
    <moeteprotokoll-rediger-deltaker-ekstern [skjema]="deltaker" (vedSlett)="slettEkstern(indeks)" data-testid="deltaker-ekstern"/>
  }
  <tips class="tips">{{ 'Merk at eksterne deltakere ikke kan signere protokoll elektronisk eller få tilgang til Styreplan'|translate }}</tips>
}

